import {
  configureQuery,
  DianaDataType,
  AdvancedEditorMode,
  AdvancedEditorAction,
} from '@diana/core';

export const updateLayoutRawJson = async (
  layoutId: string,
  transform: (layout: object) => object,
) => {
  const unifiedPage = await configureQuery.getEditorUnified().fn({
    mode: AdvancedEditorMode.RawJson,
    nodeId: layoutId,
    resourceId: layoutId,
    resourceType: DianaDataType.Layout,
  });

  const content = JSON.parse(unifiedPage.content);
  const result = await configureQuery.dispatchEditor().fn(AdvancedEditorAction.ApplyNodeChanges, {
    resourceId: layoutId,
    resourceType: DianaDataType.Layout,
    nodeId: layoutId,
    nodeType: unifiedPage.hierarchy.selectedNodeType,
    content: { ...content, layout: transform(content.layout) },
    mode: AdvancedEditorMode.RawJson,
  });

  if (result.isError) throw new Error(result.message);
};
